import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';

export function useAuthenticationStore() {
    const module = useVuexStore<UserStore>('data/authentication');
    const sendActivationEmail = (options: { email: string }) => module.action('sendActivationEmail')(options);
    return {
        ...module,
        sendActivationEmail,
    };
}

export default interface User {
    registrationDate: Date;
    firstDepositDate: Date | boolean; // server sends false if not deposit yet
}

type UserStore = {
    getters: {
        user(): User | null,
    }
    actions: {
        sendActivationEmail(_ctx: unknown, options: { email: string }): Promise<void>;
    }
};
